import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  orderItems: [],
  totalPrice: 0,
  quantity: 0,
  isLoading: true,
};
const orderSlice = createSlice({
  name: 'orderItems',
  initialState,
  reducers: {
    removeItem: (state, action) => {
      const itemId = action.payload;
      state.orderItems = state.orderItems.filter((item) => item.id !== itemId);
    },
    increment: (state, { payload }) => {
      const orderItem = state.orderItems.find((item) => item.id === payload.id);
      orderItem.quantity = orderItem.quantity + 1;
    },
    decrement: (state, { payload }) => {
      const orderItem = state.orderItems.find((item) => item.id === payload.id);
      orderItem.quantity = orderItem.quantity - 1;
    },
    noOfCartItems: (state) => {
      let quantity = 0;
      let totalPrice = 0;
      state.orderItems.forEach((item) => {
        quantity += item.quantity;
        totalPrice += item.quantity * item.price;
      });
      state.quantity = quantity;
      state.totalPrice = totalPrice;
    },
    addItems: (state, action) => {
      const newItem = action.payload;

      const existingItem = state.orderItems.find(
        (item) => item.id === newItem.id
      );

      if (existingItem) {
        existingItem.quantity += newItem.quantity;
      } else {
        state.orderItems.push(newItem);
      }
    },
  },
});
export const { increment, removeItem, decrement, noOfCartItems, addItems } =
  orderSlice.actions;

export default orderSlice.reducer;
